const MAX_ASSESSMENT_AGE_MS = 30 * 60 * 1000;

export const hasAssessmentResult = (row = {}) => {
  const score = row['Combined Score'];
  return score !== null && score !== undefined && typeof score !== 'boolean' && String(score).trim() !== '' && Number.isFinite(Number(score));
};

export const getProspectAssessmentState = (row = {}, now = Date.now()) => {
  const status = String(row.underwritingStatus || '').toLowerCase();
  if (status === 'completed') return 'complete';
  if (row.underwritingDispatchStatus === 'unconfirmed') return 'unconfirmed';
  if (status === 'failed') return 'failed';
  if (status === 'pending' || row.underwritingInProgress === true) {
    const started = new Date(row.underwritingStartedAt || row.addedAt || '').getTime();
    return Number.isFinite(started) && now - started > MAX_ASSESSMENT_AGE_MS ? 'delayed' : 'assessing';
  }
  if (hasAssessmentResult(row)) return 'complete';
  return row.addedAt ? 'delayed' : null;
};

// Existing scored companies retain their last assessment during a rerun.
export const isAssessmentIncomplete = (row = {}) =>
  !hasAssessmentResult(row) && getProspectAssessmentState(row) !== null && getProspectAssessmentState(row) !== 'complete';
